import { Component, Input } from '@angular/core';
import { ReportColumn } from '../../../shared/data-table/data-table.component';
import { fmtMoney } from '../../../utils/kpi-helpers';

@Component({
  selector: 'app-br-breakdown-section',
  templateUrl: './breakdown-section.component.html'
})
export class BrBreakdownSectionComponent {
  @Input() titlePrefix: string;
  @Input() jobItems: any[] = [];
  @Input() revenueItems: any[] = [];
  @Input() useDonut: boolean;
  @Input() tableRows: any[] = [];
  @Input() columns: ReportColumn[] = [];

  moneyFormatter = fmtMoney;
  readonly revenueBarColor = '#05cd99';
}
